<template>
  <div class="account">
    <!-- <div class="card approve" v-if="userinfo.passed != 1">
      <div class="approve-text">
        尊敬的用户您好，依据国家相关法律的规定，为了保证您的账户安全，请您尽快完成实名认证去认证
      </div>
      <el-button type="danger" size="small" @click="$emit('onAuth', 8)">去认证</el-button>
    </div> -->
    <div class="card account-main-row">
      <div class="section account-info">
        <div class="card-title">账户信息</div>
        <ul class="info-list">
          <li>
            <span>账号</span>
            <span class="content">{{ userinfo.username }}</span>
          </li>
          <li>
            <span>联系方式</span>
            <span class="content">{{ userinfo.mobile }}</span>
            <el-button type="text" @click="$refs.changeMobileDialog.onOpen()">修改</el-button>
          </li>
          <li>
            <span>账号密码</span>
            <span class="content">*******</span>
            <el-button type="text" @click="$refs.changePasswordDialog.onOpen()">修改</el-button>
          </li>

        </ul>
      </div>
      <div class="section attestation">
        <div class="card-title">认证信息</div>
        <ul class="mt16 info-list">
          <li class="u-flex">
            <span class="label">个人认证</span>
            <!-- <span class="type">个人认证</span> -->
            <span class="status blue" v-if="userinfo.passed == 1">已完成</span>
            <span class="status red" v-else-if="userinfo.passed == 2">认证失败</span>
            <span class="status gray" v-else>未完成</span>
          </li>
          <li class="u-flex">
            <span class="label">企业认证</span>
            <span class="status  blue el-red" v-if="userinfo.cstatus == 0">等待审核</span>
            <span class="status  blue" v-else-if="userinfo.cstatus == 1">已完成</span>
            <span class="status red" v-else-if="userinfo.cstatus == 2">认证失败</span>
            <span class="status  gray" v-else>未完成</span>
          </li>
        </ul>
      </div>
      <!-- <div class="section setting">
        <div class="card-title">设置</div>
        <ul class="mt16 info-list">
          <li class="u-flex u-row-between">
            <span class="label">到期短信续费提醒</span>
            <el-switch
                class="ml20"
                v-model="value"
                active-color="#2682ff"
                inactive-color="#f02811"
            />
          </li>
          <li class="u-flex u-row-between">
            <span class="label">自动续费短信提醒</span>
            <el-switch
                class="ml20"
                v-model="value"
                active-color="#2682ff"
                inactive-color="#f02811"
            />
          </li>
        </ul>
      </div> -->
    </div>
<!--    <div class="card logout">-->
<!--      <div class="card-title">注销账号</div>-->
<!--      <p class="logout-tip">您可以在此注销当前熊猫代理账号。账号注销成功后，当前账号内的所有服务将不可用，除法律法规另有规定外，当前账号内-->
<!--        信息、数据将在规定时间内删除，并将无法恢复。</p>-->
<!--      <el-button class="mt24" type="primary" size="small">注销账号</el-button>-->
<!--    </div>-->


    <Dialog ref="changeMobileDialog" width="600px" title="修改手机号" @close="() => { $refs.mobileForm.resetFields() }"
      @confirm="onChangeMobile">
      <el-form :model="mobileForm" ref="mobileForm" label-width="100px" label-position="left">
        <el-form-item label="验证码" prop="mobile" :rules="[{ required: true, message: '请输入新手机号' }]">
          <el-row :gutter="3">
            <el-col :span="12">
              <el-input v-model="mobileForm.mobile" type="text" placeholder="请输入新手机号" />
            </el-col>
            <el-col :span="8" :push="1">
              <el-button type="primary"
                @click="() => { captchaForm.event = 'changemobile'; captchaForm.mobile = mobileForm.mobile; getCaptcha() }">获取验证码</el-button>
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item label="验证码" prop="captcha" :rules="[{ required: true, message: '请输入验证码' }]">
          <el-input v-model="mobileForm.captcha" type="text" placeholder="请输入验证码" />
        </el-form-item>

      </el-form>
    </Dialog>

    <Dialog ref="changePasswordDialog" width="600px" title="修改密码" @confirm="onChangePassword"
      @close="() => { $refs.passwordFormRef.resetFields() }">
      <el-form :model="passwordForm" ref="passwordFormRef" label-width="100px" label-position="left">
        <el-form-item label="验证码" prop="captcha" :rules="[{ required: true, message: '请输入验证码' }]">
          <el-row :gutter="3">
            <el-col :span="12">
              <el-input v-model="passwordForm.captcha" type="text" placeholder="请输入验证码" />
            </el-col>
            <el-col :span="8" :push="1">
              <el-button type="primary"
                @click="() => { captchaForm.event = 'resetpwd'; captchaForm.mobile = userinfo.mobile; getCaptcha() }">获取验证码</el-button>
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item label="新密码" prop="newpassword" :rules="[{ required: true, message: '请输入新密码' }]">
          <el-input v-model="passwordForm.newpassword" type="text" placeholder="请输入新密码" />
        </el-form-item>
      </el-form>
    </Dialog>
  </div>
</template>

<script>
import Dialog from './Dialog.vue'
export default {
  name: 'Index',
  components: {
    Dialog
  },
  data() {
    return {
      orderNo: '',
      orderType: '',
      typeOptions: [{ value: 0, label: '全部订单' }],
      value: '',
      dataSource: [],
      userinfo: {},
      mobileForm: {
        captcha: '',
        mobile: '',
      },
      passwordForm: {
        captcha: '',
        newpassword: '',
        mobile: ''
      },
      captchaForm: {
        event: '',
        mobile: ''
      }
    }

  },
  mounted() {
    this.curIdx = this.$route.params.index || 0
  },
  created() {
    this.getData()
  },
  methods: {
    onChangeMobile() {
      this.$refs.mobileForm.validate((valid) => {
        if (valid) {
          this.$api.user.changeMobile(this.mobileForm).then(res => {
            this.$message.success('修改手机号成功')
            this.$refs.changeMobileDialog.onClose()
            this.$refs.mobileForm.resetFields()
          })
        }
      })
    },
    onChangePassword() {
      this.$refs.passwordFormRef.validate((valid) => {
        if (valid) {
          this.passwordForm.mobile = this.userinfo.mobile
          this.$api.user.resetPwd(this.passwordForm).then(res => {
            this.$message.success('修改密码成功')
            this.$refs.changePasswordDialog.onClose()
            this.$refs.passwordFormRef.resetFields()
          })
        }
      })
    },
    getCaptcha() {
      this.$api.user.getCaptcha(this.captchaForm).then(res => {
        this.$message.success(res.msg)
      })
    },
    getData() {
      this.$api.user.getUserInfo().then(res => {
        this.userinfo = res.data
      })
    },
    onTab(index) {
      this.navIndex = index
    },
    onReplace() {
      this.$confirm('是否确认该操作?', '提示', {
        customClass: 'custom-confirm',
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'none'
      }).then(() => {

      })
    }
  }
}
</script>

<style scoped>
.account {
  width: 100%;
  margin: 0 auto;
  padding: 0 0 32px 0;
}

.card {
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 16px 0 rgba(38, 130, 255, 0.08);
  padding: 24px 20px 24px 20px;
  margin-bottom: 24px;
}

.account-main-row {
  display: flex;
  flex-direction: row;
  gap: 32px;
  align-items: flex-start;
}

.section {
  flex: 1 1 0;
  min-width: 0;
}

.card-title {
  font-size: 18px;
  font-weight: bold;
  color: #222;
  margin-bottom: 12px;
  text-align: left;
}

.info-list {
  margin: 0;
  padding: 0;
  list-style: none;
}

.info-list li {
  display: flex;
  align-items: center;
  width: 100%;
  line-height: 36px;
  color: #000;
  font-size: 15px;
  margin-bottom: 8px;
}

.info-list li .label {
  color: #666;
  min-width: 90px;
}

.info-list li .content {
  padding: 0 20px;
  color: #333;
}

.info-list li .type {
  padding: 0 20px;
  color: #666;
}

.status.tag {
  display: inline-block;
  min-width: 56px;
  text-align: center;
  border-radius: 12px;
  font-size: 13px;
  padding: 2px 10px;
  margin-left: 12px;
}

.status.tag.blue {
  background: #e6f0ff;
  color: #2682ff;
}

.status.tag.red {
  background: #ffeaea;
  color: #f02811;
}

.status.tag.gray {
  background: #f2f2f2;
  color: #999;
}

.setting .info-list li {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  white-space: nowrap;
}

.setting .label {
  flex: 1;
  min-width: 0;
  text-align: left;
}

.setting .el-switch {
  margin-left: 0;
  flex-shrink: 0;
}

.logout-tip {
  color: #888;
  font-size: 14px;
  padding: 20px 0 0 0;
  line-height: 24px;
}

.mt16 {
  margin-top: 16px;
}

.mt24 {
  margin-top: 24px;
}

@media (max-width: 1200px) {
  .account-main-row {
    gap: 16px;
  }
}

@media (max-width: 900px) {
  .account {
    padding: 0 8px 24px 8px;
  }

  .card {
    padding: 16px 4px 16px 4px;
  }

  .account-main-row {
    flex-direction: column;
    gap: 12px;
  }
}
</style>
